import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_EMAILS_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_EMAILS,
} from '@modules/general-settings/submodules/emails/constants';
import { useI18n } from '@modules/i18n/composables';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsEmailsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_EMAILS_ROUTE_NAME,
      path: 'emails',
      permission: ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS.MAILERS_MANAGER_EDIT,
      component: () => import('@modules/general-settings/submodules/emails/pages/AdminGeneralSettingsEmailsPage/AdminGeneralSettingsEmailsPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_EMAILS, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_EMAILS_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS.MAILERS_MANAGER_EDIT,
      id: ADMIN_GENERAL_SETTINGS_EMAILS_ROUTE_NAME,
      order: 40,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_EMAILS, getTranslationKeys);
  }
}
